(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-sf-product-description]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const content = section.querySelector('[data-sf-description-content]');
      const button = section.querySelector('[data-sf-description-toggle]');
      const paragraphs = [...content.querySelectorAll('p')].filter(p => p.textContent.trim());
      // Preview up to three original paragraphs, retaining the full description on expansion.
      const previewEnd = Math.min(2, paragraphs.length - 1);
      if (paragraphs.length <= previewEnd + 1) return;
      const tail = [];
      // Hide following branches, retaining nested formatting and the original product HTML.
      for (let node = paragraphs[previewEnd]; node && node !== content; node = node.parentElement) {
        for (let sibling = node.nextSibling; sibling;) {
          const next = sibling.nextSibling;
          if (sibling.nodeType === 1) tail.push(sibling);
          else if (sibling.nodeType === 3 && sibling.textContent.trim()) {
            const span = document.createElement('span');sibling.replaceWith(span);span.append(sibling);tail.push(span);
          }
          sibling = next;
        }
      }
      if (!tail.length) return;
      tail.forEach(node => {node.dataset.sfDescriptionTail = '';node.hidden = true;});
      button.hidden = false;
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        tail.forEach(node => node.hidden = !expanded);
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? 'View less' : 'View more';
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
